/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ServiceLevelConfigurationResource } from './';
import {
    ServiceLevelConfigurationResourceFromJSON,
    ServiceLevelConfigurationResourceFromJSONTyped,
    ServiceLevelConfigurationResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ServiceLevelResource
 */
export interface ServiceLevelResource {
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelResource
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelResource
     */
    name?: string;
    /**
     * 
     * @type {Array<ServiceLevelConfigurationResource>}
     * @memberof ServiceLevelResource
     */
    configurations?: Array<ServiceLevelConfigurationResource>;
}

/**
 * Check if a given object implements the ServiceLevelResource interface.
 */
export function instanceOfServiceLevelResource(value: object): value is ServiceLevelResource {
    return true;
}

export function ServiceLevelResourceFromJSON(json: any): ServiceLevelResource {
    return ServiceLevelResourceFromJSONTyped(json, false);
}

export function ServiceLevelResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceLevelResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'configurations': json['configurations'] == null ? undefined : ((json['configurations'] as Array<any>).map(ServiceLevelConfigurationResourceFromJSON)),
    };
}

export function ServiceLevelResourceToJSON(value?: ServiceLevelResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'configurations': value['configurations'] == null ? undefined : ((value['configurations'] as Array<any>).map((v) => ServiceLevelConfigurationResourceToJSON(v))),
    };
}

